/**
 * @fileoverview Zod schema for My Page's "Reopen" form.
 * @description One optional field, the reason for reopening, up to 500 characters. The message is a
 * translation key, translated only at the display call site in MyPageReopenDialog.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { z } from 'zod'

import { MY_PAGE_REASON_MAX_LENGTH } from '@/features/sales/constants/my-page.constants'

/** @description The reopen form's rules. */
export const myPageReopenFormSchema = z.object({
  reason: z
    .string()
    .trim()
    .max(MY_PAGE_REASON_MAX_LENGTH, 'sales.myWork.dialogs.errors.reasonTooLong'),
})

/** @description The reopen form's values. */
export type MyPageReopenFormValues = z.infer<typeof myPageReopenFormSchema>
